const svgParsingStepsMap = {
  import_svg: 'import_svg',
  metadata_filling: 'metadata_filling',
  editing: 'editing',
}

export default svgParsingStepsMap
